import React from "react";
import "../../styles/Contact.css";

const ContactSection = () => {
  return (
    <section id="contact" className="contact section">
      {/* Section Title */}
      <div className="container section-title" data-aos="fade-up">
        <h2>Contact</h2>
        <p>
          <span>Need Help?</span>
          <span className="description-title">Contact Us</span>
        </p>
      </div>
      {/* End Section Title */}

      <div className="container" data-aos="fade-up" data-aos-delay="100">
        <div className="mb-5">
          <iframe
            style={{ width: "100%", height: "400px" }}
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3962.0289243608813!2d111.00551569999999!3d-6.7663276!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e70d3c7d6649313%3A0x96e6afbd6abd81!2sSablon%20%26%20Kaos%20Custom%20Originality%20(%20ORIGINALITY%20CLOTHING%20COMPANY%20)!5e0!3m2!1sen!2sid!4v1768571206153!5m2!1sen!2sid"
            frameBorder="0"
            allowFullScreen
            aria-hidden="false"
            tabIndex="0"
          ></iframe>
        </div>
        {/* End Google Maps */}

        <div className="row gy-4">
          <div className="col-md-6">
            <div
              className="info-item d-flex align-items-center"
              data-aos="fade-up"
              data-aos-delay="200"
            >
              <i className="icon bi bi-geo-alt flex-shrink-0"></i>
              <div>
                <h3 className="mm">Address</h3>
                <p className="mm">
                  Jl. Raya Pati - Kudus Km.4 Gg. Desa Badegan, Kecamatan
                  Margorejo
                </p>
              </div>
            </div>
          </div>
          {/* End Info Item */}

          <div className="col-md-6">
            <div
              className="info-item d-flex align-items-center"
              data-aos="fade-up"
              data-aos-delay="300"
            >
              <i className="icon bi bi-telephone flex-shrink-0"></i>
              <div>
                <h3 className="mm">Call Us</h3>
                <p>081 272 800 800</p>
              </div>
            </div>
          </div>
          {/* End Info Item */}

          <div className="col-md-6">
            <div
              className="info-item d-flex align-items-center"
              data-aos="fade-up"
              data-aos-delay="400"
            >
              <i className="icon bi bi-envelope flex-shrink-0"></i>
              <div>
                <h3 className="mm">Email Us</h3>
                <p>originalitycloth2016@gmail.com</p>
              </div>
            </div>
          </div>
          {/* End Info Item */}

          <div className="col-md-6">
            <div
              className="info-item d-flex align-items-center"
              data-aos="fade-up"
              data-aos-delay="500"
            >
              <i className="icon bi bi-clock flex-shrink-0"></i>
              <div>
                <h3 className="mm">
                  Opening Hours
                  <br />
                </h3>
                <p className="mm">
                  <strong>Mon-Sat:</strong> 8:00 AM - 5:00 PM; <br />
                  <strong>Sunday:</strong> Closed
                </p>
              </div>
            </div>
          </div>
          {/* End Info Item */}
        </div>

        {/* End Contact Form */}
      </div>
    </section>
  );
};

export default ContactSection;
